/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BidirectionalActionConfigPhoneNumber
 */
export interface BidirectionalActionConfigPhoneNumber {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    required: boolean;
}

/**
 * Check if a given object implements the BidirectionalActionConfigPhoneNumber interface.
 */
export function instanceOfBidirectionalActionConfigPhoneNumber(value: object): value is BidirectionalActionConfigPhoneNumber {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    return true;
}

export function BidirectionalActionConfigPhoneNumberFromJSON(json: any): BidirectionalActionConfigPhoneNumber {
    return BidirectionalActionConfigPhoneNumberFromJSONTyped(json, false);
}

export function BidirectionalActionConfigPhoneNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionConfigPhoneNumber {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'required': json['required'],
    };
}

export function BidirectionalActionConfigPhoneNumberToJSON(json: any): BidirectionalActionConfigPhoneNumber {
    return BidirectionalActionConfigPhoneNumberToJSONTyped(json, false);
}

export function BidirectionalActionConfigPhoneNumberToJSONTyped(value?: BidirectionalActionConfigPhoneNumber | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'required': value['required'],
    };
}

